export default "__VITE_ASSET__1e3d0685__"